import is from '@sindresorhus/is';

export const containsMarkdownTable = (text: string): boolean => {
    const lines = text.split('\n');
    return lines.some((line, index) => {
        const nextLine = lines[index + 1];
        if (is.undefined(nextLine)) return false;
        return /^\s*\|.+\|\s*$/.test(line) && /^\s*\|?[\s:-]+\|[\s|:-]*$/.test(nextLine);
    });
};
